export default "__VITE_ASSET__BGdS_BPQ__"